/* kr-ak · Farbwelt atmet mit + rosa Warenkorb-Ergänzung (7Million Agency)
   Pink-Zonen: eine Zone reicht von einer Pink-Bühne bis zum Ende der folgenden Sektion (data-kr-hold),
   damit das Pink länger anhält. Nur opacity wird animiert. */
(function () {
  if (window.__krFx) return; window.__krFx = true;
  var layer = document.querySelector('.kr-bgfx');
  if (!layer) { layer = document.createElement('div'); layer.className = 'kr-bgfx'; layer.setAttribute('aria-hidden', 'true'); document.body.prepend(layer); }
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  var zones = [], cur = 0, target = 0, raf = 0, pink = false;
  var SEL = '[id^="kr-ak-zahl-"] .kr-ak-stage, [id^="kr-ak-mr-"] .kr-ak-stage, [id^="kr-ak-lim"] .kr-ak-stage';
  var HOLD = { 'kr-ak-zahl-': '[id^="kr-ak-mr-"]', 'kr-ak-lim': '[id^="kr-ak-faq-"]' };
  function collect() {
    zones = [].slice.call(document.querySelectorAll(SEL)).map(function (st) {
      st.classList.add('kr-ak-grow');
      var sec = st.closest('section'), end = null;
      for (var k in HOLD) if (sec && sec.id.indexOf(k) === 0) {
        var shop = sec.closest('.shopify-section'), nx = shop && shop.nextElementSibling;
        while (nx && !nx.querySelector(HOLD[k])) nx = nx.nextElementSibling;
        end = nx ? nx.querySelector(HOLD[k]) : null;
      }
      return { a: st, b: end };
    });
  }
  function smooth(a, b, x) { x = Math.min(1, Math.max(0, (x - a) / (b - a))); return x * x * (3 - 2 * x); }
  function measure() {
    var vh = window.innerHeight, best = 0;
    for (var i = 0; i < zones.length; i++) {
      var ra = zones[i].a.getBoundingClientRect(), top = ra.top, bot = ra.bottom;
      if (zones[i].b) bot = zones[i].b.getBoundingClientRect().bottom - 40;
      var vis = Math.min(bot, vh) - Math.max(top, 0);
      if (vis <= 0) continue;
      var cov = vis / vh;
      if (cov > best) best = cov;
    }
    return smooth(0.5, 0.82, best);
  }
  function tick() {
    raf = 0;
    target = measure();
    cur = reduce.matches ? target : cur + (target - cur) * 0.18;
    if (Math.abs(target - cur) < 0.004) cur = target;
    layer.style.opacity = cur.toFixed(3);
    var p = cur > 0.45;
    if (p !== pink) { pink = p; document.body.classList.toggle('kr-is-pink', p); }
    if (cur !== target) raf = requestAnimationFrame(tick);
  }
  function req() { if (!raf) raf = requestAnimationFrame(tick); }
  collect(); req();
  window.addEventListener('scroll', req, { passive: true });
  window.addEventListener('resize', req, { passive: true });
  document.addEventListener('shopify:section:load', function () { collect(); req(); });

  /* Sticky-Leiste: Button legt die gewählte Menge direkt in den Warenkorb (statt nur zu scrollen) */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('.kr-sticky .kr-ak-btn');
    if (!b) return;
    var form = document.querySelector('[data-kr-ak-buy] [data-form]');
    if (!form || typeof form.requestSubmit !== 'function') return;
    e.preventDefault(); e.stopPropagation();
    form.requestSubmit();
  }, true);

  /* Vorher-Nachher-Regler: mit dem Finger irgendwo im Bild wischen oder tippen (statt nur am unsichtbaren Regler) */
  function initCmp(box) {
    if (box.__krCmp) return; box.__krCmp = true;
    var r = box.querySelector('input[type=range]'); if (!r) return;
    r.style.pointerEvents = 'none';
    var active = false, decided = false, sx = 0, sy = 0;
    function setX(x) {
      var b = box.getBoundingClientRect();
      var p = Math.max(0, Math.min(100, (x - b.left) / b.width * 100));
      box.style.setProperty('--pos', p.toFixed(1) + '%'); r.value = Math.round(p);
    }
    box.addEventListener('pointerdown', function (e) {
      active = true; sx = e.clientX; sy = e.clientY; decided = e.pointerType !== 'touch';
      if (decided) { setX(e.clientX); try { box.setPointerCapture(e.pointerId); } catch (err) {} }
    });
    box.addEventListener('pointermove', function (e) {
      if (!active) return;
      if (!decided) {
        var dx = Math.abs(e.clientX - sx), dy = Math.abs(e.clientY - sy);
        if (dx < 4 && dy < 4) return;
        if (dy > dx * 1.2) { active = false; return; }
        decided = true; try { box.setPointerCapture(e.pointerId); } catch (err) {}
      }
      setX(e.clientX);
    });
    box.addEventListener('pointerup', function (e) { if (active && !decided) setX(e.clientX); active = false; });
    box.addEventListener('pointercancel', function () { active = false; });
  }
  [].forEach.call(document.querySelectorAll('[data-cmp]'), initCmp);
  document.addEventListener('shopify:section:load', function () { [].forEach.call(document.querySelectorAll('[data-cmp]'), initCmp); });

  /* Nur auf dieser Seite: Du-Ansprache im Footer-Newsletter */
  [].forEach.call(document.querySelectorAll('.shopify-section-group-footer-group h2, .shopify-section-group-footer-group h3, .shopify-section-group-footer-group p, .shopify-section-group-footer-group label'), function (el) {
    if (el.children.length === 0 && /Melden Sie sich für unseren Newsletter an/.test(el.textContent)) el.textContent = el.textContent.replace('Melden Sie sich für unseren Newsletter an', 'Melde dich für unseren Newsletter an');
  });

  /* Preiszeile: Inhalt in eigene Zeile (kein einzelnes „g“ im Umbruch) */
  [].forEach.call(document.querySelectorAll('.kr-box__legal'), function (el) {
    if (el.querySelector('.kr-legal-inhalt')) return;
    el.innerHTML = el.innerHTML.replace(/·\s*(Inhalt[^<·]*)\s*$/, '<span class="kr-legal-inhalt">$1</span>').replace(/(Grundpreis[^<·]*)/, '<span style="white-space:nowrap">$1</span>');
  });

  /* Warenkorb: Sicherheits-Hinweis + Zahlungs-Icons unter den Kasse-Button (nach jedem Neu-Rendern) */
  var tpl = document.getElementById('kr-cartpay');
  var drawer = document.querySelector('cart-drawer');
  if (tpl && drawer) {
    var addPay = function () {
      if (drawer.querySelector('.cart-item')) {
        if (drawer.classList.contains('is-empty')) drawer.classList.remove('is-empty');
        var it = drawer.querySelector('cart-drawer-items.is-empty'); if (it) it.classList.remove('is-empty');
      }
      var ctas = drawer.querySelector('.drawer__footer .cart__ctas');
      if (ctas && !drawer.querySelector('.kr-cartpay')) ctas.insertAdjacentElement('afterend', tpl.content.firstElementChild.cloneNode(true));
    };
    addPay();
    new MutationObserver(addPay).observe(drawer, { childList: true, subtree: true });
  }
})();
